import React, { Component } from "react";
import { DragSource } from "react-dnd";
import { useTranslation } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";

// Own dndType so the rule tree never accepts this drag — only the chat
// panel's drop zone does.
export const chatAttachmentDndType = "QiaChatAttachment";

const selectionChipSpec = {
    beginDrag: (componentProps) => ({ attachments: componentProps.buildAttachments() }),
    endDrag: (componentProps, monitor) => {
        if (monitor.didDrop()) componentProps.onAttached();
    },
};
const selectionChipCollect = (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
});

function SelectionChipContent({ branchCount, nodeCount, onClear }) {
    const { t } = useTranslation();
    let branchesLabel = branchCount === 1 ? t("trecho selecionado") : t("trechos selecionados");
    return (
        <React.Fragment>
            <DragIndicatorIcon style={{ width: "18px", height: "18px" }} />
            <span className="qia-selection-chip-text">
                {branchCount + " " + branchesLabel + " (" + nodeCount + " " + (nodeCount === 1 ? t("nó") : t("nós")) + ")"}
            </span>
            <span className="qia-selection-chip-hint">{t("Arraste para o chat")}</span>
            <button
                type="button"
                className="qia-selection-chip-clear"
                aria-label={t("Limpar seleção")}
                onMouseDown={(event) => event.stopPropagation()}
                onClick={onClear}
            >
                <CloseIcon style={{ width: "14px", height: "14px" }} />
            </button>
        </React.Fragment>
    );
}

class selectionDragChipBase extends Component {
    render() {
        const { connectDragSource, isDragging, branchCount, nodeCount, onClear } = this.props;
        return connectDragSource(
            <div className={"qia-selection-chip" + (isDragging ? " qia-selection-chip-dragging" : "")}>
                <SelectionChipContent branchCount={branchCount} nodeCount={nodeCount} onClear={onClear} />
            </div>,
            { dropEffect: "copy" }
        );
    }
}

// Floating pill shown while branches are selected in selection mode; dragging
// it into the chat attaches the selected branches to the next message.
const SelectionDragChip = DragSource(
    chatAttachmentDndType,
    selectionChipSpec,
    selectionChipCollect
)(selectionDragChipBase);

export default SelectionDragChip;
